module.exports = __webpack_public_path__ + "static/media/spells-gameplay-mockup.e0327799.png";